import React, {Fragment} from 'react'

import {
  EuiBreadcrumbs,
  EuiSpacer
} from '@elastic/eui'


export default function ManualBreadcrumbs() {

  const breadcrumbs = [
    {
      text: 'MQTT WebUI',
      href: '/en/Web_User_Interface/1080p_Series/Network/MQTT/',
    },
    {
      text: 'MQTT Software',
      href: '/en/Advanced_User/INSTAR_MQTT_Broker/#kompatible-software',
    },
    {
      text: 'Debugging',
      href: '/en/Advanced_User/INSTAR_MQTT_Broker/Windows_macOS_und_LINUX_Apps/',
    },
    {
      text: '1080p CGI Commands',
      href: '/en/1080p_Series_CGI_List/Complete_CGI_List/',
    },
    {
      text: 'MQTT vs. CGI',
      href: '/en/Advanced_User/INSTAR_MQTT_Broker/MQTT_vs_HTTP_API/',
    },
    {
      text: 'MQTT API',
      href: '/en/Advanced_User/INSTAR_MQTT_Broker/MQTT_API/',
    },
    {
      text: 'INSTAR MQTT',
      href: '/en/Advanced_User/INSTAR_MQTT_Broker/',
    },
    {
      text: '◄ Developers',
      href: '/en/Advanced_User/',
    }
  ];

  return (
    <Fragment>
      <EuiBreadcrumbs
        truncate={true}
        breadcrumbs={breadcrumbs}
        max={11}
        aria-label="Topics for Developers"
      />
      <EuiSpacer />
    </Fragment>
  );
}